
import moment from "moment";
import "moment/locale/id";
const momentLocal = moment.locale("id");

export const createArrayEntityFromObject = (obj) => {
  return Object.keys(obj);
};

export const getEntity = (keys, obj) => {
  return keys
    .map((k) => {
      if (typeof obj[k] == "boolean") {
        // console.log("obj[k]", obj[k], "[k]", [k]);
        return obj[k];
        // return { key: [k], value: obj[k] };
      } else {
        if (obj[k]) return { key: [k], value: obj[k] };
      }
    })
    .filter((el) => el != undefined);
};

export const getEntityPy = (keys, obj) => {
  return keys
    .map((k) => {
      if (typeof obj[k] == "boolean" || typeof obj[k] == "number") {
        // console.log("obj[k]", obj[k], "[k]", [k]);
        // return obj[k];
        return { key: [k], value: obj[k] };
      } else {
        if (obj[k]) return { key: [k], value: obj[k] };
      }
    })
    .filter((el) => el != undefined);
};

export function showSvg(res) {
  let blob = new Blob([res], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);
  return url;
}

export const createQueryUrl = (arr, separator) => {
  let query = "";
  arr.map((el, n) => {
    if (arr.length - 1 > n)
      return (query = `${query}${el.key}=${el.value}${separator}`);
    if (typeof el.value == "boolean" || typeof el.value == "number") {
      // console.log("el", el);
      query = `${query}${el.key}=${el.value}`;
    } else if (el.value) {
      query = `${query}${el.key}=${el.value}`;
    }
  });
  // console.log(query);
  return query;
};

export const findArray = (arr, fromKey, value, returnKey) => {
  if (arr.find((el) => el[fromKey].includes(value))) {
    return arr.find((el) => el[fromKey].includes(value))[returnKey];
  } else {
    return null;
  }
};

export const formatCurrency = (value, language = "in-IN") => {
  if (value == "" || value == null || value == undefined) return "Rp 0";
  return new Intl.NumberFormat(language, {
    style: "currency",
    currency: "IDR",
  }).format(value);
};

export const onlyNumber = (evt) => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46)
    return evt.preventDefault();
  return true;
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const isNumeric = (number) => {
  if (+number === +number) {
    // if is a number
    return true;
  }

  return false;
};

export const backTo = (url, query = {}) => {
  window.location.replace(url);
};

export const checkType = (data) => {
  if (data) {
    if (parseInt(data) != NaN) {
      return parseInt(data);
    }
    return data;
  }
};

export const createNewArray = (array, keys, nested = {}) => {
  let returnArr = [];
  array.map((arr) => {
    let obj = {};
    keys.map((key) => {
      obj[key.to] = arr[key.from];
    });
    if (nested && arr[nested.from]) {
      obj[nested.to] = createNewArray(arr[nested.from], keys, nested);
    }
    returnArr.push(obj);
  });
  return returnArr;
};

export const toMonthName = (monthNumber) => {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return moment(date).format("MMMM");
};

export const subStringText = (message, start, end, a) => {
  if (message?.length >= a) {
    return message.substring(start, end) + "...";
  } else {
    return message;
  }
};

export const camelCase = (text) => {
  return text
    .toLowerCase()
    .split(" ")
    .map((el, ind) => {
      if (el) {
        return el[0].toUpperCase() + el.substring(1, el.length);
      }
    })
    .join(" ");
};

export const replaceText = (text, from, to) => {
  return text.replaceAll(from, to);
};

export const humanizedText = (text) => {
  return text.replaceAll("-", " ").replaceAll("_", " ");
};

export const handleLongText = (text = "-", maxLength) => {
  if (text.length > maxLength) return text.substring(0, maxLength + 3) + "...";
  return text;
};

export const handleUrl = (url) => {
  const changeUrl = ["pickup-student", "attendance-pro", "point-guard"];
  const data = changeUrl.find((item) => url.includes(item));
  if (data) {
    url = url.replaceAll("token", localStorage.getItem("token_redux"));
  }
  return url;
};

export const addSeparatorText = (text = "", length, separator = " ") => {
  let arr = [];
  let txt = "";
  text.split("").map((el, ind) => {
    txt += el;
    if (ind % length == length - 1) {
      arr.push(txt);
      txt = "";
      return;
    }
    if (ind == text.length - 1) {
      arr.push(txt);
      txt = "";
      return;
    }
  });
  return arr.join(" ");
};

export const default_menu_options = {
  create_time: "2023-02-20T10:32:23",
  creator_id: "5ec1c4c8ea40dd3912ff2070",
  is_delete: false,
  app_display_name: "PSP Mobile",
  app_icon_url: "psp.svg",
  app_mobile_background_header_url: "header.svg",
  app_desktop_background_header_url: "header.svg",
  app_accent_color: "#0054E6",
  app_secondary_accent_color: "#0054E6",
  app_menu: [
    {
      id: "63f2e9c7c41173cbc057724a",
      menu_name: "Isi Ulang",
      menu_path: "/topup",
      menu_icon_url: "wallet.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc057724b",
      menu_name: "Tagihan",
      menu_path: "/invoice",
      menu_icon_url: "invoice.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc057724c",
      menu_name: "Mutasi",
      menu_path: "/mutation",
      menu_icon_url: "mutation.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc057724d",
      menu_name: "Transaksi",
      menu_path: "/transaction-history",
      menu_icon_url: "transaction.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc057724e",
      menu_name: "Absensi",
      menu_path: "/attendance",
      menu_icon_url: "attendance.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc057724f",
      menu_name: "Kartu Digital",
      menu_path: "/digital-card",
      menu_icon_url: "card.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc0577250",
      menu_name: "Akun",
      menu_path: "/account",
      menu_icon_url: "account.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc0577251",
      menu_name: "Donasi",
      menu_path: "/donation",
      menu_icon_url: "donation.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc0577252",
      menu_name: "Jadwal",
      menu_path: "/schedule",
      menu_icon_url: "schedule.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc0577253",
      menu_name: "Kalender Akademik",
      menu_path: "/calendar",
      menu_icon_url: "calendar.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
    {
      id: "63f2e9c7c41173cbc0577254",
      menu_name: "Bantuan",
      menu_path: "/etc",
      menu_icon_url: "support.svg",
      menu_is_show: true,
      menu_type: "PAGE",
    },
  ],
  company_id: "5ec1c4c7ea40dd3912ff206d",
  _id: "63f2e9c7c41173cbc0577255",
};

export const showInitial = (initial) => {
  if (!initial) return "";
  if (initial.includes("BSI"))
    return initial.replaceAll("BSI", "").replaceAll("-", "");
  if (initial.includes("BCA"))
    return initial.replaceAll("BCA", "").replaceAll("-", "");
  if (initial.includes("BNI"))
    return initial.replaceAll("BNI", "").replaceAll("-", "");
  if (initial.includes("BRI"))
    return initial.replaceAll("BRI", "").replaceAll("-", "");
  if (initial.includes("MANDIRI"))
    return initial.replaceAll("MANDIRI", "").replaceAll("-", "");
  if (initial.includes("BANKJATIM"))
    return initial.replaceAll("BANKJATIM", "").replaceAll("-", "");
  if (initial.includes("BANKJATIM"))
    return initial.replaceAll("BANKJATIM", "").replaceAll("-", "");
  // return initial;
};
